import type { PopoverOrigin } from '@mui/material';

export const DEFAULT_MENU_ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};
export const DEFAULT_MENU_TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};
